import React from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function DonutChart({
  title,
  series,
  labels,
  graphColor,
  height = 350,
  grayBackground = false,
}) {
  const chartOptions = {
    series: series || [],
    options: {
      colors: graphColor || [],
      chart: {
        type: "donut",
      },
      legend: {
        position: "bottom",
        formatter: function (label, { w }) {
          const index = w?.config?.labels?.indexOf(label) || 0;
          const value = w?.config?.series[index] || 0;
          return `${label} (${value}%)`;
        },
      },
      labels: labels || [],
      plotOptions: {
        pie: {
          donut: {
            size: "80%",
            width: "50%",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      yaxis: {
        labels: {
          formatter: function (value) {
            return value + "%";
          },
        },
      },
    },
  };
  return (
    <Card
      className={`d-flex flex-column flex-grow-1 h-100 m-0 ${
        grayBackground ? "bg-light bg-opacity-25 shadow-none" : ""
      }`}
    >
      <GraphCardsHeader title={title} titleCenter={true} />

      <Card.Body className="flex-grow-1">
        <div
          id="chart"
          className="d-flex align-items-center justify-content-center"
        >
          <Chart
            options={chartOptions.options}
            series={chartOptions.series}
            type="donut"
            height={height}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default DonutChart;
